/**
 * Created by shobhitjain on 19/12/19.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';

/*
 *  Alert component
 *  param @alertColorClass @alertDisplayText for Background
 *  alert color and DisplayText is mandatory
 *
 * */
export const AlertComponent = ({ alertColorClass, alertDisplayText }) => (
  <Alert color={alertColorClass}>
    <p>
      <i className="fa fa-info-circle" />
      &nbsp;&nbsp;
      {alertDisplayText}
    </p>
  </Alert>
);

AlertComponent.propTypes = {
  alertColorClass: PropTypes.string.isRequired,
  alertDisplayText: PropTypes.string.isRequired
};

/*
 *  Clickable Alert component
 *  param onAlertClick function is mandatory
 * */

export const ClickableAlertComponent = ({ onAlertClick, alertDisplayText }) => (
  <Alert color="danger">
    <p>
      <i className="fa fa-info-circle" />
      &nbsp;&nbsp;
      {alertDisplayText}{' '}
      <a className="alert__a--click" onClick={onAlertClick}>
        here
      </a>
    </p>
  </Alert>
);

ClickableAlertComponent.propTypes = {
  onAlertClick: PropTypes.func.isRequired,
  alertDisplayText: PropTypes.string.isRequired
};
